import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnection } from '@microsoft/signalr';
import { NotificationType } from 'src/app/backend-client/models/SharedKernel/Messaging/SignalR/notification-type';
import {
  MxAppInitService,
  MxNotificationService,
  MxNotificationSeverity,
} from '.';

@Injectable({
  providedIn: 'root',
})
export class MxSignalRService {
  private _hubConnection: HubConnection;

  get hubConnection(): HubConnection {
    return this._hubConnection;
  }

  constructor(
    private appInitService: MxAppInitService,
    private notificationService: MxNotificationService
  ) {}

  async start(username: string) {
    if (!this.appInitService.currentConfig.signalR.url) {
      return;
    }

    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(
        `${this.appInitService.currentConfig.signalR.url}?username=${username}`
      )
      .build();

    await this.hubConnection.start();

    this.hubConnection.on(
      this.appInitService.currentConfig.signalR.notificationSubscribtion,
      (message: Message) => {
        const mess = message.messageContent.replace('\r\n', '<br>');
        let notificationSeverity =
          this.notificationService.getNotificationSeverityByBackendNotificationType(
            message.type
          );

        this.notificationService.show({
          type: notificationSeverity,
          message: mess,
          title: message.messageTitle,
          sticky: notificationSeverity === MxNotificationSeverity.Error,
          clearMessages: notificationSeverity === MxNotificationSeverity.Error,
        });
      }
    );

    this.hubConnection.invoke('joinGroup', 'demo');
  }

  stop(): void {
    if (this.hubConnection) {
      this.hubConnection.stop();
    }
  }
}

export interface Message {
  senderName: string;

  sendTime: string;

  recipient: string;

  isGroupMessage: boolean;

  sequenceId: string;

  type: NotificationType;

  messageTitle: string;

  messageContent: string;

  status: MxMessageStatus;
}

export enum MxMessageStatus {
  New,
  Sent,
  Viewed,
  Removed,
}
